import request from "../../utils/request";
import { Result } from "../../models/general";

// CO-326 — data-subject export (Download my data / HR export of an employee).

export type DataExportStatus = "Pending" | "Running" | "Ready" | "Failed" | "Expired";

export interface DataExportRequestView {
  id: number;
  subjectUserId: string;
  subjectName?: string | null;
  requestedByUserId: string;
  requestedBySubject: boolean;
  requestedUtc: string;
  status: DataExportStatus;
  sizeBytes?: number | null;
  completedUtc?: string | null;
  expiresUtc?: string | null;
  canDownload: boolean;
  error?: string | null;
}

/** Any authenticated user: export my own data. */
export async function requestMyDataExport() {
  const response = await request.post<Result<DataExportRequestView>>("data-export/me");
  return response.data;
}

/** HR only (server-enforced, same company): export an employee's data. */
export async function requestEmployeeDataExport(userId: string) {
  const response = await request.post<Result<DataExportRequestView>>(`data-export/employee/${encodeURIComponent(userId)}`);
  return response.data;
}

/** Own requests; HR sees company requests. Always pass the subject to scope the card to one person. */
export async function listDataExports(subjectUserId: string) {
  const response = await request.get<Result<DataExportRequestView[]>>("data-export", { params: { subjectUserId } });
  return response.data;
}

/** Streams the ZIP through the authenticated endpoint and saves it. */
export async function downloadDataExport(id: number) {
  const response = await request.get(`data-export/${id}/download`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener";
  link.setAttribute("download", `mowazaf-data-export-${id}.zip`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
}
